// extracted by mini-css-extract-plugin
module.exports = {"default":"button_default__uyPHi","wrapper_loader":"button_wrapper_loader__TO22p"};